import { NotifierFunctionType } from "api/common/notifier";
import { updateGame } from "api/game/update-game";

export const executeGameAction = async ({
  gameId,
  ActionData,
  ActionId,
  DecisionId,
  enqueueSnackbar,
}: {
  gameId: string;
  ActionData?: any;
  ActionId: string;
  DecisionId: string;
  enqueueSnackbar: NotifierFunctionType;
}): Promise<void> => {
  try {
    await updateGame(gameId, {
      ActionData,
      ActionId,
      DecisionId,
    });
  } catch (error: any) {
    console.error("Error updating game:", error);
    if (error.response?.data?.message) {
      enqueueSnackbar(error.response.data.message, { variant: "error" });
    } else {
      enqueueSnackbar("An error occurred", { variant: "error" });
    }
  }
};
